module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_container"
  }, [_c('my-table', {
    attrs: {
      "items": _vm.tableDataDetail,
      "headers": _vm.tableHeaderDetail,
      "oprateBtns": _vm.oprateBtns,
      "selectShow": false,
      "oprateOption": _vm.oprateOption,
      "listLoading": _vm.listLoadingDetail,
      "totalNum": _vm.TotalNumDetail,
      "pageSize": _vm.detileParams.pageSize
    },
    on: {
      "getTableData": _vm.getTableDataDetail
    },
    scopedSlots: _vm._u([{
      key: "caozuo",
      fn: function(ref) {
        var props = ref.props;

        return [_c('span', {
          staticClass: "caozuo_span",
          on: {
            "click": function($event) {
              return _vm.getDetailPage(props.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }, {
      key: "CheckStatusText",
      fn: function(ref) {
        var props = ref.props;

        return [_c('span', [_vm._v(_vm._s(props.row.CheckStatusText))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-988bd7b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userPages/applyRecord/applyRecord.vue
// module id = 1201
// module chunks = 1